/**
 * 本日の空室状況に関する定数と型定義
 */

import type { Airport, FlightType, Lounge, Terminal } from '@/constants/area';

/**
 * 空室状況ステータス
 */
export const AVAILABILITY_STATUS = {
  AVAILABLE: 'available',
  LIMITED: 'limited',
  FULL: 'full',
} as const;

export type AvailabilityStatus =
  (typeof AVAILABILITY_STATUS)[keyof typeof AVAILABILITY_STATUS];

/**
 * ステータスに対応するアイコンパス
 */
export const STATUS_ICONS: Record<AvailabilityStatus, string> = {
  [AVAILABILITY_STATUS.AVAILABLE]: '/vacancy-available.svg',
  [AVAILABILITY_STATUS.LIMITED]: '/vacancy-limited.svg',
  [AVAILABILITY_STATUS.FULL]: '/vacancy-full.svg',
};

/**
 * ステータスに対応する代替テキスト
 */
export const STATUS_ALT: Record<AvailabilityStatus, string> = {
  [AVAILABILITY_STATUS.AVAILABLE]: '○',
  [AVAILABILITY_STATUS.LIMITED]: '△',
  [AVAILABILITY_STATUS.FULL]: '×',
};

/**
 * 時間帯の空室情報
 */
export interface TimeSlot {
  /** 開始時間（時） */
  start_hour: number;
  /** 開始時間（分） */
  start_minute: number;
  /** 終了時間（時）、nullの場合はラウンジ終了時間 */
  end_hour: number | null;
  /** 空室状況 */
  status: AvailabilityStatus;
}

/**
 * ラウンジの空室情報
 */
export interface LoungeAvailability {
  /** 空港 */
  airport: Airport;
  /** 便種別 */
  flight_type: FlightType;
  /** ターミナル */
  terminal: Terminal;
  /** ラウンジ種別 */
  lounge: Lounge;
  /** 時間帯ごとの空室情報 */
  time_slots: TimeSlot[];
}

/**
 * 本日の空室状況APIレスポンス
 */
export interface TodayAvailabilityResponse extends LoungeAvailability {
  /** 対象日付 (YYYY-MM-DD形式) */
  date: string;
}
